import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-passport',
  templateUrl: './passport.component.html',
  styleUrls: ['./passport.component.css'],
})
export class PassportComponent implements OnInit {
  isSecondarySideNavOpen: boolean;
  constructor(public router: Router) {}

  ngOnInit(): void {}

  updateSecondarySideNavStatus($event: any): void {
    // console.log($event);
    this.isSecondarySideNavOpen = $event;
  }

  prepareRoute(outlet: RouterOutlet): any {
    return (
      outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation
    );
  }
}
